export const ProductCodesMap: Record<string, string> = {
  "0": "B.S.P./B.S.P.",
  "1": "ITC PACKAGES",
  "2": "LOCALLY PAID HOTEL",
  "3": "LOCALLY PAID CAR",
  "4": "OCEAN CRUISES",
  "5": "INSURANCE",
  "6": "MISCELLANEOUS",
  "7": "NON ARC AIR",
  "8": "CONSOLIDATOR",
  "9": "GIFT CERTIFICATES",
  "10": "PREPAID HOTELS",
  "11": "PREPAID CARS",
  "12": "PLAN TO GO FEE",
  "13": "LOCALLY PAID DAY",
  "18": "SERVICE FEES",
  "19": "OVERDUE INTEREST",
  "20": "RAIL",
  "21": "MERCHANT FEE CAD",
  "22": "MERCHANT FEE USD",
  "23": "SEAT SELECTION",
  "24": "FIT group",
  "25": "50/50 (Support Use O",
  "29": "OPC Contribution FIC",
  "28": "Municipal Tax MAT-Miscellaneous",
  "30": "Bonus commission",
  "31": "TRANSFERS - PREPAID",
  "32": "TRANSFERS - LOCALLY",
  "33": "ADD COLLECT",
  "34": "ESCORTED GUIDED TOUR",
  "35": "RIVER CRUISES",
  "36": "PREPAID DAY TOURS",
  "37": "PARKS AND ATTRACTIONS -TOUR",
  "38": "FIT PACKAGES",
  "39": "EXPEDITION TOURS",
};

/** The client pays the supplier directly on these, so travcom holds no payable for them. */
export const LOCALLY_PAID_PRODUCT_CODES: readonly number[] = [2, 3, 13, 32];
